module.exports = __webpack_public_path__ + "static/media/play-pass.826cf98d.mp3";